import {Component, Input, OnInit} from '@angular/core';
import {AppConfigService} from '../../config/app-config.service';
import {ExternalAppsDto} from './external-apps-dto.model';
import {HtmlUtilsService} from "../../html-utils/html-utils.service";

@Component({
  selector: 'app-external-apps',
  templateUrl: './external-apps.component.html',
  styleUrls: ['./external-apps.component.scss']
})
export class ExternalAppsComponent implements OnInit {

  externalApps: ExternalAppsDto;
  private highContrast: boolean = false;

  constructor(private appConfig: AppConfigService,
              private htmlUtils: HtmlUtilsService) {
    this.externalApps = appConfig.externalApps;
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit() {
  }

}
